import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import editorStyles from '@mdxeditor/editor/style.css?raw'
import appStyles from './index.css?raw'

const STYLE_ID = 'mdx-markdown-styles'
const CHANGE_DEBOUNCE_MS = 300

function injectStyles() {
  if (document.getElementById(STYLE_ID)) return
  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = editorStyles + appStyles
  document.head.appendChild(style)
}

function debounce(fn, ms) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => fn(...args), ms)
  }
}

class MdxMarkdownElement extends HTMLElement {
  connectedCallback() {
    injectStyles()

    const def = this.componentDefinition || {}
    const initialValue = this.fieldValue ?? def.defaultValue ?? ''

    this._mountEl = document.createElement('div')
    this.appendChild(this._mountEl)

    this._root = createRoot(this._mountEl)
    this._root.render(
      <App markdown={initialValue} definition={def} onChange={this._onChange} />
    )
  }

  disconnectedCallback() {
    if (this._root) this._root.unmount()
    if (this._mountEl) this._mountEl.remove()
  }

  // Push edits into the Formbird document store. The element itself stands in
  // as the FormComponent: valueChanged reads fieldName, document and
  // formParameters off it. Debounced so we dispatch on pause, not per keystroke.
  _onChange = debounce((markdown) => {
    const service = window.FormbirdServiceInjector?.get('ChangedDocumentService')
    if (service && this.document && this.fieldName) {
      service.valueChanged(this, markdown)
    }
  }, CHANGE_DEBOUNCE_MS)
}

if (!customElements.get('mdx-markdown')) {
  customElements.define('mdx-markdown', MdxMarkdownElement)
}
